<template>
  <v-app >
    <nav-bar />
    <v-content class="mt-0 page_background">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
  import NavBar from "./components/navbar-component/NavBar";

  export default {
    name: 'App',
    components: {
      NavBar,
    },
    created() {
    },
  async mounted() {
    await this.$apollo.provider.defaultClient.hydrated();
    this.hydrated = true;
  }
};
</script>
